// @flow

import React from 'react';
import styled from 'styled-components';
import { injectIntl } from 'react-intl';
import * as CookieConsentLib from 'vanilla-cookieconsent';

import messages from './messages';

/**
 * Persistent "Cookie Settings" trigger. Reopens the preferences modal so the user
 * can withdraw or change consent at any time — making withdrawal as easy as
 * granting (a GDPR requirement).
 *
 * Placed in the footer (see components/Footer). To add another trigger anywhere
 * else, any element with `data-cc="show-preferencesModal"` will also open the
 * modal once the library has initialized — no extra code needed.
 */

const Button = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: rgba(60, 64, 66, 0.6);
  font-size: 13px;
  line-height: 15px;
  display: block;
  margin-bottom: 8px;
  text-align: left;

  &:hover {
    text-decoration: underline;
  }
`;

type Props = {
  intl: Object,
};

const CookieSettingsLink = ({ intl }: Props) => (
  <Button type="button" onClick={() => CookieConsentLib.showPreferences()}>
    {intl.formatMessage(messages.settingsLink)}
  </Button>
);

export default injectIntl(CookieSettingsLink);
